import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import dayjs from 'dayjs';
import { investigationScheduledDateUpdateAll } from 'src/app/shared/helpers/auth-config/investigations.config';
import { SortOrder } from 'src/app/shared/modules/graphql/enums/generic.enums';
import { InvestigationOnSceneSource, InvestigationOnSceneStatus } from 'src/app/shared/modules/graphql/enums/investigation.enums';
import { IApiInvestigationOnScene, IApiInvestigationOnSceneFilterType, IApiInvestigationOnSceneOrderBy } from 'src/app/shared/modules/graphql/types/types';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';
import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';
import { InvestigationOnSceneService } from 'src/app/shared/services';

@Component({
  selector: 'app-investigation-edit-on-scene-history',
  templateUrl: './investigation-edit-on-scene-history.component.html',
  styleUrls: ['./investigation-edit-on-scene-history.component.scss']
})
export class InvestigationEditOnSceneHistoryComponent extends DialogContentBase implements OnInit {
  @Input() investigationOnScene: IApiInvestigationOnScene;
  @ViewChild("frm") form: NgForm;
  public authConfig = {
    investigationScheduledDateUpdateAll,
  }

  public investigationOnSceneStatusAll = [
    InvestigationOnSceneStatus.SCHEDULED,
    InvestigationOnSceneStatus.EN_ROUTE,
    InvestigationOnSceneStatus.ON_SCENE,
    InvestigationOnSceneStatus.OFF_SCENE,
  ];

  public onScenes = [];
  constructor(
    public dialog: DialogRef,
    private investigationOnSceneService: InvestigationOnSceneService,
    private loader: LoaderService,
    private notification: NotificationsService
  ) {
    super(dialog)
  }

  ngOnInit(): void {
    const filters = [];
    filters.push({ type: IApiInvestigationOnSceneFilterType.UserId, value: this.investigationOnScene.User?.id });
    filters.push({ type: IApiInvestigationOnSceneFilterType.InvestigationId, value: this.investigationOnScene.Investigation?.id });
    filters.push({ type: IApiInvestigationOnSceneFilterType.ScheduledDateExact, value: this.investigationOnScene?.scheduledDate });
    const options = {
      orderBy: IApiInvestigationOnSceneOrderBy.CreatedAt,
      sortOrder: SortOrder.ASC,
      limit: -1,
      offset: 0,
    }
    this.loader.show$(this.investigationOnSceneService.get(filters, options)).subscribe((response) => {
      const history = response.edges?.map((edge) => edge.node) || [];
      this.onScenes = history.map(item => ({
        createdAt: this.convert(item?.createdAt, this.investigationOnScene?.Investigation?.timezone),
        source: item?.source,
        id: item?.id,
        status: item?.status,
        userName: `${this.investigationOnScene.User?.firstName} ${this.investigationOnScene.User?.lastName}`
      }));
    });
  }

  convert(entryDate, timezone) {
    const converted = dayjs(entryDate).tz(timezone);
    const hours = converted.hour();
    const minutes = converted.minute();
    const date = new Date(entryDate);
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setDate(converted.date());
    return date;
  }

  submit() {
    this.form.control.markAllAsTouched()
    if (!this.form.valid) {
      return;
    }
    const scenes = this.onScenes.map(onScene => {
      return {
        id: onScene.id || "",
        createdAt: dayjs(onScene?.createdAt).tz(this.investigationOnScene?.Investigation?.timezone, true).toISOString(),
        status: onScene.status,
        source: onScene.source || InvestigationOnSceneSource.NEFCO_ADMIN,
      }
    });

    const input = {
      InvestigationId: this.investigationOnScene?.Investigation?.id,
      UserId: this.investigationOnScene?.User?.id,
      scenes: scenes,
      scheduledDate: this.investigationOnScene?.scheduledDate
    }

    this.loader.show$(this.investigationOnSceneService.updateInvestigationOnSceneStatus(input).pipe(
      this.notification.snackbarPipe("On scene history updated successfully"),
      this.notification.snackbarErrorPipe("Error updating on scene history")
    )).subscribe(response => {
      if (response === true) {
        this.close(true);
      }
    })
  }

  addOnScene() {
    this.onScenes.push(
      {
        createdAt: null,
        source: InvestigationOnSceneSource.NEFCO_ADMIN,
        id: '',
        status: '',
        userName: `${this.investigationOnScene.User?.firstName} ${this.investigationOnScene.User?.lastName}`
      }
    )
  }

  public trackByIndex(index: number) {
    return index + "_data";
  }

  public removeEntry(index) {
    this.onScenes.splice(index, 1);
  }

  close(result = false) {
    this.dialog.close(result);
  }
}
